import React from 'react';
import 'react-quill/dist/quill.snow.css';
import { useStyletron } from 'baseui';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dynamic from 'next/dynamic';
const QuillNoSSRWrapper = dynamic(import('react-quill'), {
  ssr: false,
  loading: () => <p>Loading ...</p>
});
const Editor = ({
  onChange,
  value,
  readOnly
}) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    backgroundColor: theme.colors.backgroundPrimary,
    borderRadius: theme.borders.radius300,
    ...theme.borders.border300,
    borderColor: theme.colors.backgroundSecondary,
    borderWidth: '8px',
    position: 'relative',
    marginBottom: '14px'
  })}>
      {readOnly ? <React.Fragment>
          <div className={css({
        cursor: 'not-allowed',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%'
      })} title="Editor is read only">
            <FontAwesomeIcon icon={faLock} style={{
          color: theme.colors.primary,
          position: 'absolute',
          top: '14px',
          right: '14px'
        }} title="Editor is read only" />
          </div>
          <div className={css({
        padding: value ? '14px' : '24px'
      })} dangerouslySetInnerHTML={{
        __html: value
      }} />
        </React.Fragment> : <QuillNoSSRWrapper readOnly={readOnly} theme="snow" value={value} onChange={onChange} placeholder="" modules={{
      toolbar: [['bold', 'italic', 'link', {
        background: []
      }], [{
        list: 'ordered'
      }, {
        list: 'bullet'
      }]]
    }} />}
    </div>;
};
export default Editor;